import {Field, FieldProps} from 'formik';
import React from 'react';
import {toEnglishDigits} from '../../../utilities/helper/toEnglishNumber';
import InputOutlet from '../../InputOutlet';

interface TFormikInputProps extends React.HTMLProps<HTMLInputElement> {
  name: string;
  label: string;
  secondaryTitle?: React.ReactNode;
  touched?: boolean;
}
const FormikInput = ({
  name,
  label,
  secondaryTitle,
  touched,
  ...props
}: TFormikInputProps) => {
  return (
    <>
      <Field>
        {({form}: FieldProps) => {
          return (
            <>
              <InputOutlet
                secondaryTitle={secondaryTitle}
                required={props.required}
                label={label}
                name={name}
                type={props?.type}
                rows={props?.rows}
                value={form.values[name]}
                onBlur={() => form.setFieldTouched(name, true)}
                errors={form.errors[name]?.toString()}
                touched={
                  touched ||
                  Boolean(form.touched[name]) ||
                  form.values[name].length > 0
                }
                placeholder={props.placeholder}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value = toEnglishDigits(e.target.value);
                  form.setFieldValue(name, value);
                }}
                {...props}
              />
            </>
          );
        }}
      </Field>
    </>
  );
};

export default FormikInput;
